import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config/apiConfig';

const PastOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  console.log("Fetching orders for userId:", user?.userId);
  useEffect(() => {
    if (user?.userId) {
      fetch(`${API_BASE_URL}/api/orders/user/${user.userId}`)
        .then((res) => res.json())
        .then((data) => setOrders(Array.isArray(data) ? data : []))
        .catch((err) => console.error('Failed to load orders:', err));
    }
  }, [user]);
  console.log("Fetching orders for userId:", user?.userId);

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        {/* Breadcrumb */}
        <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-inner text-center">
                  <h2 className="title">My Past Orders</h2>
                  <ul className="page-list">
                    <li className="rbt-breadcrumb-item"><a href="/">Home</a></li>
                    <li><div className="icon-right"><i className="feather-chevron-right"></i></div></li>
                    <li className="rbt-breadcrumb-item active">Orders</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Orders */}
        <div className="rbt-my-account-area rbt-section-gap" style={{ width: '100%' }}>
        <div className="container" style={{ width: '100%' }}>
            <div className="row g-5" style={{ width: '100%' }}>
            <div className="col-lg-9 col-12" style={{ width: '100%' }}>
                <div className="rbt-my-account-inner" style={{ width: '100%' }}>
                {/* <h3 className="mb-4">Past Orders</h3> */}
                <div
                    className="rbt-my-account-table table-responsive text-center"
                    style={{ width: '100%' }}
                >
                    <table className="table table-bordered" style={{ width: '100%' }}>
                    <thead className="thead-light">
                        <tr>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Total</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.length === 0 ? (
                        <tr>
                            <td colSpan="6">No past orders found.</td>
                        </tr>
                        ) : (
                        orders.map((order) => {
                            console.log("🧾 Order:", order);

                            const item = order.items?.[0];
                            if (!item) {
                            return (
                                <tr key={order.orderID}>
                                <td colSpan="6">
                                    Order #{order.orderID} has no items.
                                </td>
                                </tr>
                            );
                            }

                            return (
                            <tr key={order.orderID}>
                                <td>
                                <img
                                    src={
                                    item.fabric?.displayImagePath ||
                                    "/assets/images/default.jpg"
                                    }
                                    alt={item.productName || "N/A"}
                                    style={{
                                    width: "60px",
                                    height: "60px",
                                    objectFit: "cover",
                                    }}
                                />
                                </td>
                                <td>{item.productName || "N/A"}</td>
                                <td>
                                {new Date(order.orderDate).toLocaleDateString()}
                                </td>
                                <td>{order.orderStatus}</td>
                                <td>${order.totalAmount.toFixed(2)}</td>
                                <td>
                                <button
                                    className="rbt-btn btn-gradient btn-sm"
                                    onClick={() => navigate(`/order/${order.orderID}`)}
                                >
                                    View Details
                                </button>
                                </td>
                            </tr>
                            );
                        })
                        )}
                    </tbody>
                    </table>
                </div>
                </div>
            </div>
            {/* Optional Sidebar */}
            </div>
        </div>
        </div>

      </main>
      <Footer />
    </>
  );
};

export default PastOrders;
